import * as React from "react";

function CardSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="rounded-[8px] border border-divider bg-surface overflow-hidden">
      <div className="border-b border-divider bg-table-header p-[16px]">
        <div className="h-[20px] w-2/5 max-w-[200px] rounded-[6px] bg-divider" />
      </div>
      <div className="grid gap-[16px] p-[16px]">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            className="flex items-center justify-between gap-[12px]"
          >
            <div className="flex items-center gap-[12px]">
              <div className="h-[30px] w-[30px] shrink-0 rounded-full bg-divider" />
              <div className="h-[12px] w-[120px] rounded-[6px] bg-divider" />
            </div>
            <div className="h-[12px] w-[60px] rounded-[6px] bg-divider" />
          </div>
        ))}
      </div>
    </div>
  );
}

function AdditionalChargesSkeleton() {
  return (
    <div>
      <div className="mb-[24px] h-[20px] w-2/5 max-w-[200px] rounded-[6px] bg-divider" />
      <div className="overflow-hidden rounded-[8px] border border-divider bg-surface">
        <div className="grid gap-[16px] p-[16px]">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="flex items-center justify-between gap-[12px]"
            >
              <div className="h-[12px] w-1/3 rounded-[6px] bg-divider" />
              <div className="h-[22px] w-[72px] rounded-[999px] bg-divider" />
            </div>
          ))}
        </div>
        <div className="px-[16px] pb-[16px]">
          <div className="h-[1px] w-full bg-divider" />
          <div className="grid gap-[8px] py-[16px]">
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className="flex items-center justify-between gap-[12px]"
              >
                <div className="h-[12px] w-1/4 rounded-[6px] bg-divider" />
                <div className="h-[12px] w-[72px] rounded-[6px] bg-divider" />
              </div>
            ))}
          </div>
          <div className="h-[1px] w-full bg-divider" />
          <div className="flex flex-wrap gap-[12px] py-[16px]">
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className="h-[40px] w-[100px] rounded-[30px] bg-divider"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function BookingDetailSkeleton() {
  return (
    <div className="mt-[16px] animate-pulse">
      <div className="mb-[16px] flex flex-wrap items-center gap-[8px]">
        <div className="h-[22px] w-2/5 max-w-[280px] rounded-[8px] bg-divider" />
        <div className="h-[28px] w-[96px] rounded-[999px] bg-divider" />
      </div>

      <div className="grid grid-cols-1 gap-[24px] lg:grid-cols-2">
        <AdditionalChargesSkeleton />
        <div className="space-y-[24px]">
          <CardSkeleton rows={4} />
          <CardSkeleton rows={1} />
          <CardSkeleton rows={3} />
        </div>
      </div>
    </div>
  );
}
